export default function getSupplierOffice(supplier) {
    let sup = supplier?.toString()?.toLowerCase();
    try {
        if(sup?.includes('dxb'))
            return 'dxb';
        else if(sup?.includes('amadeus'))
            return 'los';
        else return sup;
    } catch(ex) {}
}